import { render, staticRenderFns } from "./PayrollTypeList.vue?vue&type=template&id=39c94af4"
import script from "./PayrollTypeList.vue?vue&type=script&lang=js"
export * from "./PayrollTypeList.vue?vue&type=script&lang=js"
import style0 from "./PayrollTypeList.vue?vue&type=style&index=0&id=39c94af4&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports